<template>
  <div>
    <vue-headful title="Vacatures" />
    <Header page_title="Vacatures" />
    <div>
      <div class="app-body container-fluid vacancy-open">
        <div v-if="results ? results.data && results.data.length > 0 : false" class="">
            <p v-if="results.meta" class="mb-3"><strong>{{ results.meta.total }}</strong> openstaande vacature{{ results.data.length > 1 ? "s" : "" }}</p>
            <div id="jobs" class="mb-4" v-if="branch !== '3'">
                <JobCard
                    v-for="job in results.data"
                    :key="job.id"
                    :job="job"
                    :job_ids="job_ids"
                    :company="true"
                    :open="true"
                />
                <Pagination :results="results" :api="api" @page-change="pageChanged" />
            </div>
            <div id="jobs" class="mb-4" v-else>
                <JobCardHealthcare
                    v-for="job in results.data"
                    :key="job.id"
                    :job="job"
                    :job_ids="job_ids"
                    :company="true"
                    :open="true"
                />
                <Pagination :results="results" :api="api" @page-change="pageChanged" />
            </div>
        </div>
        <div v-else class="mb-4">
          <div class="sd-notif warning"><svg-icon icon="information" class="warning-icon"/> Er zijn op dit moment geen openstaande vacatures.</div>
        </div>
        <div class="sticky-vacancy">
          <router-link
            :to="this.branch === '3' ? { name: 'job_step-1-healthcare' } : { name: 'job_step-1' }"
            title="Plaats een vacature"
            class="btn btn-warning btn-block"
            v-ripple="'rgba(255, 255, 255, 0.35)'"
          >
            Plaats vacature
          </router-link>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import JobCard from "@/components/JobCard.vue";
import JobCardHealthcare from "@/components/JobCardHealthcare.vue";

export default {
  async created() {},
  data: function() {
    return {
      api: "jobs/open",
      results: null,
      job_ids: null,
      branch: localStorage.getItem('branch'),
    };
  },
  components: {
    JobCardHealthcare,
    JobCard
  },
  watch: {
    results: {
      immediate: true,
      async handler() {
        if (this.results ? this.results.data.length > 1 : false) {
          this.job_ids = this.results.data.map(({ job_id }) => job_id);
        }
      },
      deep: true
    }
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      this.$store.state.loading = true;
      this.results = await this.getListwithPages(this.api);
      this.$store.state.loading = false;
    },
    async pageChanged(data) {
      this.results = await this.getListwithPages(data);
    }
  }
};
</script>

<style scoped>
::v-deep .component .title {
  padding-right: 30px;
}

.vacancy-open {
  padding-bottom: 20px;
}

.sticky-vacancy {
  position: fixed;
  bottom: 60px;
  left: 0;
  right: 0;
  max-width: 768px;
  margin: 0 auto;
  padding: 15px 0;
  z-index: 3;
  background-color: #FFF;
}

.sticky-vacancy .btn {
  max-width: 551px;
  margin: 0 auto;
}
</style>
